import {useState} from 'react'

export function useEmoji() {

    const [isBubbleVisible, setIsBubbleVisible] = useState(false)
    const [messageIndex, setMessageIndex] = useState(-1)

    const messages = [
        'Hello',
        "Don't press me again, it hurts",
        'Come on, seriously',
        'Ouch',
        'Very funny, time to stop',
        "I don't want to say it again, STOP",
        "You're going to stop in 3",
        '2',
        '1',
        'Restarting device...',
        'You believed that? hahaha',
        "You're bored, aren't you?",
        "Alright, that's enough.",
        'Still going?',
        "You're starting to bore me",
        'Okay, the next one is the last',
        'Find something better to do',
        'Bye'
    ]

    const handleEmojiClick = () => {

        setIsBubbleVisible(true)

        setMessageIndex((prev) => {
            const next = prev + 1

            if (next >= messages.length) {
                return messages.length - 1
            }

            return next
        })
    }

    const currentMessage =
        messageIndex >= 0 ? messages[messageIndex] : ''

    return {
        isBubbleVisible,
        currentMessage,
        handleEmojiClick
    }
}